import React from "react";
import "./Loader.css";
import { useSelector } from "react-redux";
import { S3_BASE_URL } from "../../Service";
const Loader = () => {
  const siteData = useSelector(
    (state) => state.data.sitesetting?.siteSetting?.[0]?.data
  );
  
  // const getLogoUrl = (url) => {
  //   if (!url) return "";
  //   if (url.startsWith("http")) return url;
  //   const formattedUrl = url.startsWith("/") ? url : `/${url}`;
  //   return `${S3_BASE_URL}${formattedUrl}`;
  // };
   const getLogoUrl = (url) => {
      if (typeof url !== "string") return "";
      if (url.startsWith("http")) return url;
      const formattedUrl = url.startsWith("/") ? url : `/${url}`;
      return `${S3_BASE_URL}${formattedUrl}`;
    };
  return (
    <div className="global-loader">
      <img
        src={getLogoUrl(siteData?.logo1)}
        alt=""
        className="loader-logo"
      />
    </div>
  );
};

export default Loader;
